import { render, staticRenderFns } from "./BloodTransfusionSigned.vue?vue&type=template&id=0017e27f&"
import script from "./BloodTransfusionSigned.vue?vue&type=script&lang=js&"
export * from "./BloodTransfusionSigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports